import { useTranslate } from '@tolgee/react';
import { Modal } from 'antd';
import { useSystemLanguageValue } from 'hooks/business/system/useSystem';
import { cx } from '@emotion/css';
import { forwardRef, useImperativeHandle, useRef } from 'react';

type ConfirmProps = {
  onOk?: () => void;
};

export const Help = forwardRef((props: { mode?: 'reg' | 'login' } & ConfirmProps, ref) => {
  const { t } = useTranslate();
  const lang = useSystemLanguageValue();
  const { mode, onOk } = props;
  const spanRef = useRef<HTMLSpanElement>(null!);
  useImperativeHandle(ref, () => {
    return {
      trigger: () => {
        spanRef.current?.click();
      },
    };
  });

  return (
    <span
      className={cx('cursor-pointer text-[var(--fett-text-secondary)]', {
        'text-[11px]': lang === 'pt',
        'leading-[22px]': lang === 'pt',
      })}
      ref={spanRef}
      onClick={() => {
        mode
          ? Modal.confirm({
              title: t('reg_1'),
              okText: t(mode === 'reg' ? '使用邮箱注册' : '使用密码登录'),
              cancelText: t('ViewDashboard.取消'),
              onOk: () => onOk?.(),
              content: (
                <div>
                  <div>1、{t('reg_2')}</div>
                  <div>2、{t('reg_3')}</div>
                  <div>3、{t(mode === 'reg' ? '建议使用邮箱注册' : '建议使用密码登录')}</div>
                </div>
              ),
            })
          : Modal.info({
              title: t('reg_1'),
              okText: t('ViewDashboard.确认'),
              content: (
                <div>
                  <div>1、{t('reg_2')}</div>
                  <div>2、{t('reg_3')}</div>
                </div>
              ),
            });
      }}
    >
      {t('reg_1')}
    </span>
  );
});
